import { getAccessToken, refresh } from "@/auth"

const post = async (url, body, headers = {}) => {
	return await fetch(url, {
		method: "POST",
		body,
		headers
	})
		.then(x => {
			if (x.status >= 200 && x.status < 300) {
				if (x.status === 204) return {success: true}
				return x.json()
			}

			if (x.status >= 500 ) {
				return {
					message : 'Что-то пошло не так. Попробуйте позже.',
					name: 'server-error',
					success: false
				}
			}
			
			if (x.status == 422) {
				return {
					message : 'Неправильный код, попробуйте снова.',
					name: 'wrong-captcha',
					success: false
				}
			}

			if (x.status >= 400 && x.status < 500) {
				if (x.status === 401) {
					refresh()
					return {
						message: 'Недостаточно прав',
						name: x.status,
						success: false
					}
				}
				
				return {
					message : 'Ошибка HTTP: ' + x.status,
					name: x.status,
					success: false
				}
			}
		})
}

const postWithToken = async (url, body, headers = {}) => {
	return await post(url, body, {
		'Authorization': 'Bearer ' + getAccessToken(),
		...headers
	},)
}

export { post, postWithToken }